import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState } from 'react';
import { ScanLine, CircleCheck } from 'lucide-react';
import styles from '../ReportCard.module.scss';

/**
 * Кнопка "Сканировать QR" с запросом разрешения камеры.
 *
 * @param {Object} props
 * @param {string}  props.label   — текст кнопки ("Сканировать QR" / "Сканировать")
 * @param {boolean} props.success — показывать "✅ Подтверждено"?
 * @param {Function} props.onScan — колбэк при нажатии (после получения разрешения)
 * @param {Function} props.onNotify
 */
const ScanButton = ({ label = tr("Сканировать"), success, onScan, onNotify }) => {
  useInterfaceLanguage();
  const [requesting, setRequesting] = useState(false);
  const handleClick = async () => {
    if (requesting) return;
    setRequesting(true);
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        // Запрашиваем заднюю камеру { exact } чтобы браузер сразу открыл нужную
        let stream = null;
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: { exact: 'environment' } },
          });
        } catch (_) {
          // Fallback: ideal mode
          try {
            stream = await navigator.mediaDevices.getUserMedia({
              video: { facingMode: { ideal: 'environment' } },
            });
          } catch (_2) {
            stream = await navigator.mediaDevices.getUserMedia({ video: true });
          }
        }
        // Сразу останавливаем предварительный поток — useCamera сам стартует нужную
        if (stream) stream.getTracks().forEach(t => t.stop());
        onScan();
      } catch (err) {
        onNotify({
          isOpen: true,
          message: tr("Разрешите доступ к камере для сканирования QR-кода!"),
          type: 'error',
        });
      }
    } else {
      onNotify({
        isOpen: true,
        message: tr("Ваше устройство не поддерживает доступ к камере!"),
        type: 'error',
      });
    }
    setRequesting(false);
  };

  return (
    <>
      <button type="button" onClick={handleClick} className={styles.btn_tabel} disabled={requesting} aria-busy={requesting}>
        <ScanLine size={24} /> {requesting ? tr("Подключение камеры…") : tr(label)}
      </button>
      {tr(success && (
        <div className={styles.scanSuccess} role="status">
          <CircleCheck size={16} />{tr(" Подтверждено")}</div>
      ))}
    </>
  );
};

export default React.memo(ScanButton);
